import React, { useEffect, useState } from 'react';
import { getLeaderboard, getPlayerProfile } from './api';  
import AccueilButtons from './Components/Accueil-buttons';
import './Classement.css';

function Leaderboard() {
    const [leaderboard, setLeaderboard] = useState([]);  
    const [loading, setLoading] = useState(true);        
    const [error, setError] = useState('');              

    useEffect(() => {
        const fetchLeaderboardData = async () => {
            try {
                const response = await getLeaderboard();
                
                console.log('Leaderboard API response:', response);

                if (response && response.data && response.data.Leaderboard) {
                    const leaderboardData = response.data.Leaderboard;

                    console.log('Leaderboard Data:', leaderboardData);

                    const leaderboardWithProfileInfo = await Promise.all(
                        leaderboardData.map(async (entry) => {
                            try {
                                console.log(`Fetching player profile for PlayFabId: ${entry.PlayFabId}`);
                                const profileResponse = await getPlayerProfile(entry.PlayFabId);
                                
                                console.log(`Player profile for PlayFabId ${entry.PlayFabId}:`, profileResponse);

                                return {
                                    ...entry,
                                    displayName: profileResponse.displayName || 'Utilisateur',
                                };
                            } catch (error) {
                                console.error('Error fetching player profile:', error);
                                return {
                                    ...entry,
                                    displayName: 'Utilisateur',
                                };
                            }
                        })
                    );

                    console.log('Leaderboard with Profile Info:', leaderboardWithProfileInfo);

                    setLeaderboard(leaderboardWithProfileInfo);
                } else {
                    setError('Aucun classement disponible.');
                }
            } catch (error) {
                console.error('Error fetching leaderboard:', error);
                setError('Erreur lors de la récupération du classement.');
            } finally {
                setLoading(false);
            }
        };
    
        fetchLeaderboardData();
    }, []);

    return (
        <div className="classement-container">
            <AccueilButtons />

            <div className="Rectangle56"></div>
            <div className="Rectangle102"></div>
            <div className="Rectangle103"></div>
            <div className="Rectangle114"></div>
            <div className="Rectangle109"></div>
            <div className="Rectangle110"></div>
            <div className="Rectangle108"></div>
            <div className="Rectangle107"></div>
            <div className="Rectangle104"></div>
            <div className="Rectangle101"></div>
            <div className="Rectangle78"></div>
            <div className="Rectangle111"></div>
            <div className="Rectangle106"></div>
            <div className="Int">.Int</div>

            {loading && (
                <div className="loading-message">
                    Chargement des données
                    <div className="loading-dots">
                        <span>.</span>
                        <span>.</span>
                        <span>.</span>
                    </div>
                </div>
            )}
            {error && <p className="error-message">{error}</p>}
            
            <h1>Classement</h1>
            {!loading && !error && leaderboard.length > 0 && (
                <ul className="classement-list">
                    {leaderboard.map((entry, index) => (
                        <React.Fragment key={entry.PlayFabId || index}>
                            <li className="classement-item">
                                <span className="classement-rank">{entry.Position || index + 1}</span>
                                <span className="classement-name">{entry.displayName || 'Utilisateur'}</span> 
                                <span className="classement-login">{entry.StatValue} Connexions</span>
                            </li>
                            
                            {index === 2 && (
                               <div class="podium-separator">
                               <div class="separator-line"></div>
                               <span>Podium</span>
                               <div class="separator-line"></div>
                           </div>
                            )}
                        </React.Fragment>
                    ))}
                </ul>
            )}

            {!loading && !error && leaderboard.length === 0 && (
                <p className="no-data-message">Aucun classement disponible pour le moment.</p>
            )}
        </div>
    );
}

export default Leaderboard;
